import { Switch, Tooltip } from "@braintrust/braintrust-ui-components";
import {
  CheckIcon,
  CloseIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import type { NotificationSetting } from "@js/types/notifications";

import { useNotificationSettings } from "../allow-notifications-switch/use-unsubscribe-all-talent-notifications";

const SMS_STOP_TOOLTIP =
  "This communication was disabled by an SMS STOP reply. Send START to enable it again.";

type NotificationSwitchProps = {
  notification: NotificationSetting;
};

export const NotificationSwitch = ({
  notification,
}: NotificationSwitchProps) => {
  const { updateNotifications, areNotificationsAllowed } =
    useNotificationSettings();
  const ignoresAllowNotifications =
    notification.notification === ENUMS.NotificationTypes.SMS_COMMUNICATION;
  const stoppedViaSms = ignoresAllowNotifications && notification.disabled;

  const notificationSwitch = (
    <Switch
      checked={
        areNotificationsAllowed || ignoresAllowNotifications
          ? (notification.value as boolean)
          : false
      }
      checkedIcon={<CheckIcon />}
      icon={<CloseIcon />}
      id={notification.notification}
      disabled={notification.disabled}
      onChange={(data) => {
        void updateNotifications({
          ...notification,
          value: data.target.checked,
        });
      }}
      slotProps={{ input: { "aria-label": notification.label } }}
    />
  );

  if (!stoppedViaSms) {
    return notificationSwitch;
  }

  return (
    <Tooltip title={SMS_STOP_TOOLTIP}>
      <span data-testid="sms-stop-tooltip">{notificationSwitch}</span>
    </Tooltip>
  );
};
